import { render, staticRenderFns } from "./ChampionshipFutureSites.vue?vue&type=template&id=97f7fe54&scoped=true&"
import script from "./ChampionshipFutureSites.vue?vue&type=script&lang=js&"
export * from "./ChampionshipFutureSites.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipFutureSites.vue?vue&type=style&index=0&id=97f7fe54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f7fe54",
  null
  
)

export default component.exports